exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-0dbb20a2] {\n    font-size: 24px;\n    line-height: 36px;\n    margin-bottom: 15px;\n    font-weight: 600;\n    color: #2d3748;\n    letter-spacing: 0;\n    margin-top: 0;\n}\n.dashboard-section-title[data-v-0dbb20a2] {\n    margin-bottom: 16px;\n    margin-left: 15px;\n    font-size: 16px;\n    font-weight: 600;\n    color: #4a5568;\n}\n@media only screen and (max-width: 575px) {\nh2[data-v-0dbb20a2] {\n        font-size: 20px;\n        line-height: 32px;\n}\n}\ndiv.card[data-v-0dbb20a2] {\n  max-width: 80%;\n}\n", ""]);

// exports
